import {createStore} from '@stripe-internal/state-manager';

import type {FundingSessionState} from 'src/fund/state/types';

const initialValues: FundingSessionState = {
  screen: 'token_select',
  cryptoWalletFundingOptions: null,
  businessName: '',
  logoUrl: null,
  merchantBranding: null,
};

// Loading another funding session reloads the page and creates a fresh store.
const store = createStore(initialValues);

export const getStore = () => store;

export const {setValue, useSelector} = getStore();
